import React, { useState } from 'react';

import { Box, Button, Grid, Typography } from '@material-ui/core';

import SharedDialog from '../../../../components/SharedDialog/SharedDialog.component';
import { useAssistanceDataContext } from '../../../../context/assistance/assistance.provider';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';
import { dataLayerPush } from '../../../../helpers/dataLayerPush';
import { useTipification } from '../../../../hooks/useTipification';

const PassengersAssistance = () => {
  const { nextStep, updateAssistanceBody } = useAssistanceDataContext();
  const [open, setOpen] = useState(false);
  const { user } = useAuthDataContext();
  const { trackEvent, events } = useTipification();

  const setPassengersAssistance = (isNeeded: boolean) => {
    updateAssistanceBody({
      has_passenger_assistance: isNeeded,
    });
    dataLayerPush('asistencia_continuarRemis', user?.id);
    if (isNeeded) trackEvent(events.ASSISTANCE_NEED_REMIS);
    nextStep();
  };

  const openModal = () => {
    dataLayerPush('asistencia_necesitoRemis', user?.id);
    setOpen(true);
  };

  return (
    <>
      <SharedDialog
        open={open}
        content={
          <Box>
            <Typography variant="h6">
              ¡Ok, vamos a solicitar un remis para tu traslado!
            </Typography>
            <Box my={3}>
              <Typography>
                Tené en cuenta que el costo del mismo correrá por tu cuenta.
              </Typography>
            </Box>
          </Box>
        }
        onClose={() => setOpen(false)}
        actions={
          <Grid container justify="flex-end">
            <Grid item xs={12} sm={6}>
              <Box m={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => setPassengersAssistance(true)}
                >
                  Entendido
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>
      <Grid container>
        <Grid item xs={12}>
          <Box style={{ marginTop: '50px' }}>
            <Typography variant="h6">
              En la grúa puede viajar un único pasajero mayor de edad
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12} sm={9} md={8}>
              <Box my={4}>
                <Typography>
                  Si te encontras con menores o mascotas, ¡te pedimos que te
                  traslades en otro vehículo!
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12} md={6} lg={4}>
              <Box
                my={4}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Button
                  onClick={() => setPassengersAssistance(false)}
                  variant="contained"
                  color="primary"
                >
                  Continuar
                </Button>

                <Button
                  onClick={() => openModal()}
                  variant="outlined"
                  color="primary"
                >
                  Necesito un remís
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default PassengersAssistance;
